'use client';

import * as React from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import Icon, { IconsAvailable } from '../Icon';
import Button, { IButtonProps } from '../Button';
import Buttons from '../Buttons';
import './styles.scss';

export interface INonIdealStateProps {
  /** Text to display */
  title: React.ReactNode;
  /** Longer description to display */
  description?: React.ReactNode;
  /** One of bundled icons to display */
  icon?: IconsAvailable;
  /** Image instead of icon */
  imageUrl?: string;
  /** Custom addon to display at the bottom (e.g. button) */
  buttons?: IButtonProps[];
  /** Layouts to choose from */
  layout?: 'default' | 'horizontal';
}

/**
 * NonIdealStates visually highlight important content for the user.
 */
const NonIdealState: React.FunctionComponent<INonIdealStateProps> = (props) => {
  return (
    <div
      className={classNames('nonidealstate', {
        ['layout-default']: props.layout === 'default' || !props.layout,
        ['layout-horizontal']: props.layout === 'horizontal',
      })}
    >
      <div className={'nonidealstate__spacer'} />
      <div className={'nonidealstate__wrapper'}>
        <div className={'nonidealstate__inner'}>
          <div className={'nonidealstate__icon'}>
            {props.icon && (
              <Icon
                width={200}
                height={200}
                kind={props.icon}
              />
            )}
            {props.imageUrl && (
              <Image
                src={props.imageUrl}
                alt=""
                fill={true}
                sizes="200px"
              />
            )}
          </div>
        </div>
        <div className={'nonidealstate__content'}>
          <div className={'nonidealstate__title'}>{props.title}</div>
          {!!props.description && <div className={'nonidealstate__description'}>{props.description}</div>}
        </div>
        {props.buttons && !!props.buttons.length && (
          <div className={'nonidealstate__addon'}>
            <Buttons layout="centered">
              {props.buttons.map((button, buttonIndex) => (
                <Button
                  size="large"
                  key={buttonIndex}
                  {...button}
                />
              ))}
            </Buttons>
          </div>
        )}
      </div>
      <div className={'nonidealstate__spacer'} />
    </div>
  );
};

NonIdealState.displayName = 'NonIdealState';

export default NonIdealState;
